import { render, staticRenderFns } from "./NlpTable.vue?vue&type=template&id=23dbe6ea"
import script from "./NlpTable.vue?vue&type=script&lang=ts"
export * from "./NlpTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports